/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Title_PlaceholderInputs */

const en_admin_roles_title_placeholder = /** @type {(inputs: Admin_Roles_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Content Editor`)
};

const zh_admin_roles_title_placeholder = /** @type {(inputs: Admin_Roles_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 内容编辑`)
};

/**
* | output |
* | --- |
* | "e.g. Content Editor" |
*
* @param {Admin_Roles_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_title_placeholder = /** @type {((inputs?: Admin_Roles_Title_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Title_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_title_placeholder(inputs)
	return zh_admin_roles_title_placeholder(inputs)
});
export { admin_roles_title_placeholder as "admin.roles.title_placeholder" }